import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';
import { Section } from '../../../entities';

type UpdateSection = Partial<Omit<Section, 'id' | 'created' | 'updated' | 'condominiumId'>> & {
  condominiumId: string;
  id: string;
};

export default class UpdateSectionInput implements UpdateSection {
  @IsString()
  readonly id: string;

  @IsString()
  @IsOptional()
  readonly label?: string;

  @Expose({ name: 'condominium_id' })
  @IsString()
  readonly condominiumId: string;

  constructor(init?: UpdateSectionInput) {
    this.id = init?.id!;
    this.label = init?.label;
    this.condominiumId = init?.condominiumId!;
  }
}
